export default function validate(values, message = '') {
  const { email } = values;

  return {
    email: !email && 'Email Harus diisi' || message,
  };
}
